import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  popoverContainer: {
    width: '200px',
  },
  visibilityButton: {
    width: '5px',
    height: '5px',
    padding: '0 8px',
  },
  sortButton: {
    width: '20px',
    height: '20px',
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
  optionText: {
    padding: theme.spacing(1),
    flexGrow: 1,
    height: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  option: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: `0 ${theme.spacing(1)}`,
    display: 'flex',
    alignItems: 'center',
    '& :hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },
  dragHandleIcon: {
    width: '20px',
    height: '20px',
    fill: theme.palette.grey[900],
  },
}));

export default useStyles;
